import { StorageLocationPutawayModeSchema } from "@redotech/redo-fulfillment-wms-common/schema/storage-location";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const setStorageLocationPutawayMode = {
  name: "setStorageLocationPutawayMode" as const,
  input: z.object({
    storageLocationIds: z
      .array(storageLocationIdFormat.schema)
      .min(1)
      .max(1000),
    putawayMode: StorageLocationPutawayModeSchema.nullable(),
  }),
  output: z.object({
    updatedStorageLocationIds: z.array(storageLocationIdFormat.schema),
  }),
};
